import { render } from "./Attcfile.vue?vue&type=template&id=e455b10a"
import script from "./Attcfile.vue?vue&type=script&lang=js"
export * from "./Attcfile.vue?vue&type=script&lang=js"

import "./Attcfile.vue?vue&type=style&index=0&id=e455b10a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__